import React, { Suspense } from 'react';
import { observer } from 'mobx-react-lite';
import bem from 'utils/bem';
import Text from 'components/Text';

import OrderTeaser, { OrderTeaserSkeleton } from 'components/OrderTeaser';

import Icon from 'components/Icon';
import { times } from 'utils/render';
import Model from '../../../model';
import './index.sass'
import OfficeEmptyBlock from 'components/OfficeEmptyBlock';
import Loader from 'components/Loader';
import { IconButton } from 'components/Button';
import {PulsingDot} from "components/PulsingDot";

const { block, el } = bem('orders');

const Orders = () => {

    const { userOrdersData } = Model.user;

    return (
        <Suspense fallback={ <Loader/> }>
            <div className={ block() }>
                <OrdersBlock resource={ userOrdersData }/>
            </div>
        </Suspense>
    );
};

const OrdersBlock = observer(({ resource }) => {
    resource.read();
    const { pastOrders, activeOrders } = Model.user;
    const { openOrderForm } = Model.modal;

    if (activeOrders.length === 0 && pastOrders.length === 0) {
        return (
            <OfficeEmptyBlock
                primaryText={ 'Записи отсутствуют' }
                secondaryText={ 'Вы еще не записывались к специалистам' }
                buttonText={ 'Записаться на консультацию' }
                onClick={ openOrderForm }
                icon={ 'calendar-blank' }
            />
        )
    }
    return (
        <>
            <div className={el('order-button')}>
                <IconButton mod={'gold'} name={ 'calendar-blank' } onClick={ openOrderForm }>
                    <Text>Записаться на консультацию</Text>
                </IconButton>
            </div>
            { activeOrders.length > 0 && <div className={ el('block') }>
                <div className={ el('title') }>
                    <PulsingDot />
                    <Text>Активные записи</Text>
                </div>
                <div className={ el('info') }>
                    <Icon name={ 'info' }/>
                    <Text>Перенос и отмена онлайн записи возможны не позже, чем за 12 часов до начала, для очной
                        24</Text>
                </div>
                <div className={ el('info') }>
                    <Icon name={ 'info' }/>
                    <Text>Время начала консультации указано по Московскому времени</Text>
                </div>
                <div className={ el('list') }>
                    { activeOrders.map(order => <OrderTeaser key={ order.id } order={ order } />) }
                </div>
            </div> }
            { pastOrders.length > 0 &&
                <div className={ el('block') }>
                    <div className={ el('title') }>
                        <PulsingDot idle={true} />
                        <Text>Прошедшие записи</Text>
                    </div>
                    <div className={ el('list') }>
                        { pastOrders.map(order => <OrderTeaser key={ order.id } order={ order }/>) }
                    </div>
                </div>
            }
        </>
    )
});

const OrdersBlockSkeleton = () => {
    return (
        <>
            <div className={ el('block') }>
                <div className={ el('title') }>
                    <div className={ el('indicator', 'active') }/>
                    <Text>Активные записи</Text>
                </div>
                <div className={ el('info') }>
                    <Icon name={ 'info' }/>
                    <Text>Перенос и отмена онлайн записи возможны не позже, чем за 12 часов до начала, для очной
                        24</Text>
                </div>
                <div className={ el('list') }>
                    { times((key) => <OrderTeaserSkeleton key={ key }/>, 2) }
                </div>
            </div>
            <div className={ el('block') }>
                <div className={ el('title') }>
                    <span className={ el('indicator', 'past') }/>
                    <Text>Прошедшие записи</Text>
                </div>
                <div className={ el('list') }>
                    { times((key) => <OrderTeaserSkeleton key={ key }/>, 1) }
                </div>
            </div>
        </>
    )
}

export default observer(Orders);
